
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-gallery-thumb]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const main=document.querySelector('[data-gallery-main]');
      if(main){main.src=btn.dataset.src;document.querySelectorAll('[data-gallery-thumb]').forEach(b=>b.classList.remove('is-active'));btn.classList.add('is-active');}
    });
  });
  const form=document.querySelector('[data-acustep-form]');
  const dataEl=document.getElementById('AcuStepVariants');
  if(!form||!dataEl) return;
  const variants=JSON.parse(dataEl.textContent||'[]');
  let size='39', color='Beige/Marrone';
  const hidden=form.querySelector('input[name="id"]');
  const button=form.querySelector('[data-buy]');
  function sync(){
    const v=variants.find(x=>String(x.option1)===size && String(x.option2)===color);
    if(v){
      hidden.value=v.id;
      button.disabled=!v.available;
      button.textContent=v.available?'Aggiungi al carrello — '+formatMoney(v.price):'Non disponibile';
      const priceEl=document.querySelector('[data-price]');
      const compareEl=document.querySelector('[data-compare]');
      if(priceEl) priceEl.textContent=formatMoney(v.price);
      if(compareEl){
        if(v.compare_at_price && Number(v.compare_at_price)>Number(v.price)){
          compareEl.style.display='';
          compareEl.textContent=formatMoney(v.compare_at_price);
        }else{
          compareEl.style.display='none';
          compareEl.textContent='';
        }
      }
    } else {
      button.disabled=true;
      button.textContent='Combinazione non disponibile';
    }
  }
  function formatMoney(cents){return (Number(cents)/100).toLocaleString('it-IT',{style:'currency',currency:'EUR'});}
  document.querySelectorAll('[data-size]').forEach(el=>el.addEventListener('click',()=>{size=el.dataset.size;document.querySelectorAll('[data-size]').forEach(x=>x.classList.remove('is-selected'));el.classList.add('is-selected');sync();}));
  document.querySelectorAll('[data-color]').forEach(el=>el.addEventListener('click',()=>{color=el.dataset.color;document.querySelectorAll('[data-color]').forEach(x=>x.classList.remove('is-selected'));el.classList.add('is-selected');sync();}));
  sync();
});